'use strict';

var lib = require('./lib-75591456.js');
var icon = require('./icon-e3ab87ed.js');

var LEAF = 'M17.1665 7.49988C9.0665 9.29988 7.1765 14.8529 5.3045 19.5059L7.0055 20.0999L7.8605 18.0299C8.2925 18.1829 8.7425 18.2999 9.0665 18.2999C18.9665 18.2999 21.6665 2.99988 21.6665 2.99988C20.7665 4.79988 14.4665 5.02488 9.9665 5.92488C5.4665 6.82488 3.6665 10.6499 3.6665 12.4499C3.6665 14.2499 5.2415 15.8249 5.2415 15.8249C8.1665 7.49988 17.1665 7.49988 17.1665 7.49988Z';
var IconLeaf = lib.variant('IconLeaf', icon.Icon, {
    path: LEAF,
});

exports.IconLeaf = IconLeaf;
//# sourceMappingURL=index-97468912.js.map
